/* eslint-disable import/prefer-default-export */

const { lang } = document.querySelector('#myaccount').dataset;
const langfile = lang == 'fr' ? require('./fr.js').default : require('./en.js').default;

export function printLang(code) {
  if (! code) return '';
  const path = code.split('.');
  let output = langfile;
  for (let i = 0; i < path.length; i++) {
    const step = path[i];
    if (output[step]) {
      output = output[step];
    } else {
      break;
    }
  }
  if (typeof output == 'string') return output;
  console.warn(`invalid lang code ${code}`);
  return '';
}
